import { createSelector } from 'reselect'

const selectFlashMessages = (state) => state.get('flashMessages')

export const makeSelectFlashMessages = () => createSelector(selectFlashMessages, (messages) => messages)
